// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1rMLT","info":"UpdateTermsInfo_info__mGoa4"};